import React, {Component} from 'react';
import {pdfjs} from 'react-pdf';
import {Document,Page} from 'react-pdf';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faAngleLeft} from '@fortawesome/pro-solid-svg-icons/faAngleLeft';
import {faAngleRight} from '@fortawesome/pro-solid-svg-icons/faAngleRight';
pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

class PdfViewer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            numPages: null,
            pageNumber: 1,
            minHeight: 'inherit'
        };
        this.onDocumentLoad = this.onDocumentLoad.bind(this);
        this.prev = this.prev.bind(this);
        this.next = this.next.bind(this);
        this.renderSuccess = this.renderSuccess.bind(this);
    }

    onDocumentLoad({numPages}) {
        this.setState({numPages});
    }

    prev() {
        if (this.state.pageNumber <= 1) {
            this.setState({pageNumber: this.state.numPages})
        } else {
            this.setState({pageNumber: this.state.pageNumber - 1})
        }
    }

    renderSuccess() {
        const height = document.getElementById('pdfHolder').clientHeight;
        this.setState({minHeight: height})
    }

    next() {
        if (this.state.pageNumber >= this.state.numPages) {
            this.setState({pageNumber: 1})
        } else {
            this.setState({pageNumber: this.state.pageNumber + 1})
        }
    }

    render() {
        const {pageNumber, numPages} = this.state;
        return (
            <div className="pdf-embed">
                <div className="mb-2 text-right">
                    <div className="btn-group">
                        <a className="btn btn-primary mr-2" target="_blank"
                           download
                           href={this.props.pdfUrl}>Downloaden</a>
                        {numPages > 1 ?
                            <>
                                <div onClick={this.prev} className="btn btn-primary mr-2">
                                    <FontAwesomeIcon icon={faAngleLeft}/>
                                </div>
                                <div className="lead my-auto font-weight-bold mr-2">
                                    {pageNumber} / {numPages}
                                </div>
                                <div onClick={this.next} className="btn btn-primary">
                                    <FontAwesomeIcon icon={faAngleRight}/>
                                </div>
                            </>
                            :
                            <div className="lead my-auto font-weight-bold">
                                {pageNumber} / {numPages}
                            </div>
                        }
                    </div>
                </div>
                <div id="pdfHolder" className="text-center" style={{'minHeight': this.state.minHeight}}>
                    <Document
                        file={this.props.pdfUrl} renderAnnotations={false} renderAnnotationLayer={false}
                        onLoadSuccess={this.onDocumentLoad}>
                        <Page onRenderSuccess={this.renderSuccess} scale={1} pageNumber={pageNumber} renderAnnotations={false}
                              renderAnnotationLayer={false}/>
                    </Document>
                </div>
            </div>
        )
    }
}

export default PdfViewer;
